<template>
  <div :class="{ 'brand-panel': true, active: show }" @click.stop>
    <el-checkbox-group v-model="checkList" @change="changeCheck">
      <div class="tree-box">
        <div class="choose-box">
          <div class="choose-parent">
            <div class="choose-item" v-for="item in list" :key="item.id" @click="expandSecond(item)">
              <div class="checkBox" @click.stop>
                <el-checkbox :label="item.name"></el-checkbox>
              </div>
              <div class="txt-box">
                <span>{{ item.name }}</span>
              </div>
              <div class="icon-box" v-show="item.children && item.children.length > 0">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="choose-box">
          <div class="choose-parent">
            <div class="choose-item" v-for="item in secondList" :key="item.id" @click="expandThird(item)">
              <div class="checkBox" @click.stop>
                <el-checkbox :label="item.name"></el-checkbox>
              </div>
              <div class="txt-box">
                <span>{{ item.name }}</span>
              </div>
              <div class="icon-box" v-show="item.children && item.children.length > 0">
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="choose-box">
          <div class="choose-parent">
            <div class="choose-item" v-for="item in thirdList" :key="item.id" @click="expandThird(item)">
              <div class="checkBox" @click.stop>
                <el-checkbox :label="item.name"></el-checkbox>
              </div>
              <div class="txt-box">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-checkbox-group>
    <div class="footer">
      <button class="btn btn-cancel" @click="cancel">取消</button>
      <button class="btn btn-reset" @click="reset">重置</button>
      <button class="btn btn-confirm" @click="confirm">确定</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      list: [],
      secondList: [],
      thirdList: [],
      checked: false,
      checkList: []
    };
  },
  methods: {
    open(show, list, value) {
      this.show = show;
      this.list = list;
      this.checkList = [value];
    },
    cancel() {
      this.show = false;
    },
    reset() {
      this.checkList = [];
    },
    confirm() {
      if (this.checkList.length > 0) {
        this.$emit("change", this.checkList[0]);
      } else {
        this.$emit("change");
      }
      this.cancel();
    },
    changeCheck(v) {
      if (v.length > 1) {
        v.splice(0, v.length - 1);
      }
    },
    expandSecond(item) {
      if (item.children) {
        this.secondList = item.children;
      } else {
        this.secondList = [];
      }
    },
    expandThird(item) {
      if (item.children) {
        this.thirdList = item.children;
      } else {
        this.thirdList = [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/* 隐藏复选框后面的标签文字 */
::v-deep .el-checkbox__label {
  display: none;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

::v-deep .el-checkbox__inner {
  width: 14px;
  height: 14px;

  &::after {
    left: 4px;
    top: 1px;
    width: 3px;
    height: 6px;
  }
}

.brand-panel {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e4e7ed;
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-height: 540px;
  display: none;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  min-width: 600px;
}

.brand-panel.active {
  display: flex;
}

.tree-box {
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  min-height: 300px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  .choose-box {
    width: 100%;
    max-height: 400px;
    overflow-y: auto;
    border: 1px solid #f0f0f0;
    border-radius: 6px;
    overflow: hidden;

    .choose-parent {
      display: flex;
      flex-direction: column;

      .choose-item {
        width: 100%;
        padding: 10px 12px;
        display: flex;
        align-items: center;
        cursor: pointer;
        gap: 8px;
        border-bottom: 1px solid #f5f5f5;
        transition: all 0.2s ease;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          background: #f0f7ff;

          .txt-box span {
            color: var(--color-primary);
          }

          .icon-box {
            color: var(--color-primary);
          }
        }

        .checkBox {
          flex-shrink: 0;
          width: 15px;
        }

        .txt-box {
          flex: 1;
          min-width: 0;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          text-align: left;

          span {
            font-size: 13px;
            color: #333;
            font-weight: 500;
            transition: color 0.2s;
          }
        }

        .icon-box {
          flex-shrink: 0;
          width: 10px;
          color: #c0c4cc;
          font-size: 12px;
          transition: color 0.2s, transform 0.2s;
        }

        &:hover .icon-box {
          transform: translateX(2px);
        }
      }
    }
  }
}

.footer {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn {
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
  border: 1px solid #dcdfe6;
  background: white;
  color: #606266;

  &:hover {
    border-color: #c0c4cc;
    background-color: #f5f7fa;
  }
}

.btn-cancel {
  color: #606266;
}

.btn-reset {
  color: #f56c6c;
  border-color: #f56c6c;

  &:hover {
    background-color: #fef0f0;
    border-color: #f78989;
  }
}

.btn-confirm {
  background: linear-gradient(135deg, var(--color-primary) 0%, #66b1ff 100%);
  border: none;
  color: white;

  &:hover {
    background: linear-gradient(135deg, #66b1ff 0%, var(--color-primary) 100%);
    transform: translateY(-1px);
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
  }
}

// 滚动条样式
.tree-box::-webkit-scrollbar,
.choose-box::-webkit-scrollbar {
  width: 4px;
}

.tree-box::-webkit-scrollbar-track,
.choose-box::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.tree-box::-webkit-scrollbar-thumb,
.choose-box::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.tree-box::-webkit-scrollbar-thumb:hover,
.choose-box::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

// 响应式设计
@media (max-width: 768px) {
  .brand-panel {
    max-height: 400px;
    min-width: unset;
    width: 100vw;
    left: 0;
    right: 0;
  }

  .tree-box {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .choose-box {
    .choose-parent .choose-item {
      padding: 8px 10px;
    }
  }

  .footer {
    padding: 10px 12px;
    flex-wrap: wrap;

    .btn {
      flex: 1;
      min-width: 70px;
    }
  }
}
</style>
